import { useTranslation } from 'react-i18next'

import type { SidebarCreditsTypes } from './SidebarCredits.types'

export const SidebarCredits = ({
  credits,
  impersonationCredits = 0,
  isLoading,
}: SidebarCreditsTypes) => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col justify-between p-4 group-data-[collapsible=icon]:flex-col group-data-[collapsible=icon]:gap-1 group-data-[collapsible=icon]:px-2 border-b border-neutralColor5 gap-4 bg-baseColor group-data-[collapsible=icon]:items-center">
      <p className="text-sm text-neutralColor font-normal group-data-[collapsible=icon]:hidden">
        {t('dashboard.sidebar.creditsBalance')}
      </p>
      <div className="flex items-center gap-1 justify-between">
        <span className="text-xs text-neutralColor60 font-medium group-data-[collapsible=icon]:hidden">
          {t('dashboard.sidebar.creditsRemaining')}
        </span>
        <p className="text-sm font-medium text-neutralColor">
          {isLoading ? '...' : credits}
        </p>
      </div>
      <div className="flex items-center gap-1 justify-between">
        <span className="text-xs text-neutralColor60 font-medium group-data-[collapsible=icon]:hidden">
          {t('dashboard.sidebar.impersonationCreditsRemaining')}
        </span>
        <p className="text-sm font-medium text-neutralColor">
          {isLoading ? '...' : impersonationCredits}
        </p>
      </div>
    </div>
  )
}
